export function setEditItem(state, payload) {

    if (!payload.birth_date || payload.birth_date == 'null') {
        payload.birth_date = "";
    }
    if (!payload.birth_month || payload.birth_month == 'null') {
        payload.birth_month = "";
    }
    if (!payload.birth_year || payload.birth_year == 'null') {
        payload.birth_year = "";
    }

    if (!payload.department_id) {
        payload.department_id = null;
    }

    if (!payload.company_role_id) {
        payload.company_role_id = null;
    }

    if (!payload.job_title) {
        payload.job_title = "";
    }

    if (!payload.dream_job) {
        payload.dream_job = "";
    }

    if (!payload.university) {
        payload.university = "";
    }

    if (!payload.degree) {
        payload.degree = null;
    }

    if (!payload.graduation_year) {
        payload.graduation_year = "";
    }

    if (!payload.super_power) {
        payload.super_power = null;
    }

    state.editItem = Object.assign({}, payload);
}

export function resetUser(state, payload) {
    state.editItem = {};
}

export function setInterests(state, payload) {
    state.interests = payload;
}

export function setUploadImageModal(state, payload) {
    state.uploadImageModal = payload
}

export function resetStore(state) {
    state.editItem._id = ""
    state.editItem.agora_id = null
    state.editItem.agreed_tnc = null
    state.editItem.birthday_mode = null
    state.editItem.birthyear_mode = null
    state.editItem.city = ""
    state.editItem.coach_bio = ""
    state.editItem.coach_power = ""
    state.editItem.company = ""
    state.editItem.country = ""
    state.editItem.cover_image = ""
    state.editItem.created_at = ""
    state.editItem.degree = null
    state.editItem.dob = ""
    state.editItem.birth_date = null
    state.editItem.birth_month = ""
    state.editItem.birth_year = null
    state.editItem.dream_job = ""
    state.editItem.email = ""
    state.editItem.email_mode = true
    state.editItem.email_verification_app_type = ""
    state.editItem.email_verification_send_time = ""
    state.editItem.f_name = ""
    state.editItem.favourite_book = "null"
    state.editItem.favourite_food = "null"
    state.editItem.graduation_year = "null"
    state.editItem.interests = []
    state.editItem.isFollow = false
    state.editItem.is_email_verified = null
    state.editItem.job_title = ""
    state.editItem.job_type = null
    state.editItem.jobseeking = null
    state.editItem.l_name = ""
    state.editItem.mob_no = ""
    state.editItem.mobno_mode = null
    state.editItem.no_followers = null
    state.editItem.no_following = null
    state.editItem.notification_status = ""
    state.editItem.notification_token = null
    state.editItem.preferences = {}
    state.editItem.profile_image = ""
    state.editItem.role_ids = []
    state.editItem.roles = []
    state.editItem.send_mail_verification = 1
    state.editItem.state = ""
    state.editItem.status = ""
    state.editItem.std_code = ""
    state.editItem.student_type = null
    state.editItem.super_power = null
    state.editItem.timezone = ""
    state.editItem.token = ""
    state.editItem.univ_dept = null
    state.editItem.university = ""
    state.editItem.updated = null
    state.editItem.updated_at = ""
    state.editItem.username = null
    state.editItem.work_phone = null
    state.editItem.zip = null
    state.editItem.company_role_id = null
    state.editItem.department_id = null
    state.interest.name = ""
    state.interests = []
    state.editItem.coaching_block_ids = []

}